import { useEffect, useRef, useState } from 'react'
import { Button, Typography, Box } from '@mui/material'
import { playWarningBeep } from '../context/AudioContext/AudioContext'

export default function useAntiScreenshot({ userId, moduleId, addLog }) {
  const [isSuspicious, setSuspicious] = useState(false)

  // biar beep & log gak spam
  const lastTriggerRef = useRef(0)

  useEffect(() => {
    const handleKeyUp = (e) => {
      const now = Date.now()
      if (now - lastTriggerRef.current < 1500) return // cooldown 1.5 detik

      const key = e.key?.toLowerCase()
      const meta = e.getModifierState?.('Meta')
      const shift = e.getModifierState?.('Shift')

      const isPrintScreen = key === 'printscreen'
      const isMacScreenshot = meta && shift && (key === '3' || key === '4')
      const isWinSnip = meta && shift && key === 's'

      if (isPrintScreen || isMacScreenshot || isWinSnip) {
        lastTriggerRef.current = now

        // WARNING SOUND
        playWarningBeep()
        setSuspicious(true)

        // log async (micro delay biar gak block UI)
        setTimeout(async () => {
          try {
            await addLog?.(userId, moduleId, 'Percobaan screenshot')
          } catch (err) {
            console.error('Gagal kirim log screenshot:', err)
          }
        }, 10)
      }
    }

    window.addEventListener('keyup', handleKeyUp)
    return () => window.removeEventListener('keyup', handleKeyUp)
  }, [userId, moduleId, addLog])

  const handleClose = () => {
    setSuspicious(false)
  }

  const ScreenshotDialog = () =>
    isSuspicious && (
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="rgba(0,0,0,0.6)"
        zIndex={9999}
        sx={{
          backdropFilter: 'blur(6px)',
          color: 'white',
          flexDirection: 'column',
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" fontWeight={700}>
          ⚠️ Screenshot Terdeteksi!
        </Typography>
        <Typography variant="body1" mt={1} mb={2}>
          Aktivitas ini <strong>terdeteksi dan direkam oleh sistem</strong>.
          <br />
          Mohon untuk tidak melakukan tangkapan layar selama tes berlangsung.
        </Typography>
        <Button variant="contained" color="warning" onClick={handleClose}>
          Saya Mengerti
        </Button>
      </Box>
    )

  return { isSuspicious, ScreenshotDialog }
}
